import TextField from '@mui/material/TextField'
import {DatePicker, DateTimePicker} from '@mui/x-date-pickers'
import {withStyles} from '@mui/styles'
import {Colors, TextFieldBorders} from './index'

export const INPUT_STYLES = {
  root: {
    '& label': {
      color: Colors.rxrBlueColor,
      padding: '2px 4px',
    },
    '& label.Mui-focused': {
      color: Colors.rxrBlueColor,
    },
    '& label.Mui-disabled': {
      color: Colors.rxrDarkGreyColor,
    },
    '& label.Mui-error': {
      color: Colors.rxrRedColor,
    },
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      backgroundColor: Colors.rxrWhiteColor,
      '& fieldset': {
        ...TextFieldBorders.textfieldInputBorder,
      },
      '&:hover fieldset': {
        ...TextFieldBorders.textfieldInputBorder,
      },
      '&.Mui-disabled fieldset': {
        ...TextFieldBorders.textfieldInputBorderDisabled,
      },
      '&.Mui-focused fieldset': {
        ...TextFieldBorders.textfieldInputBorder,
      },
      '&.Mui-error fieldset': {
        ...TextFieldBorders.textfieldInputBorderError,
      },
      '& .MuiInputAdornment-root': {
        '& .MuiIconButton-root': {
          '&:focus': {
            outline: '0px auto transparent',
          },
        },
      },
    },
    '& .MuiInputBase-root': {
      ...Colors.rxrBlue,
      '&.Mui-disabled': {
        backgroundColor: Colors.rxrLightGreyColor,
        ...Colors.darkGrey,
      },
      '&.Mui-error': {
        ...Colors.red,
      },
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiFormHelperText-root': {
      ...Colors.rxrBlue,
      '&.Mui-disabled': {
        ...Colors.darkGrey,
      },
      '&.Mui-error': {
        ...Colors.red,
      },
    },
  },
}

export const FormTextField = withStyles(INPUT_STYLES)(TextField)
